import React from "react";

export const BoxShadowIcon = ({
    fill="#fff",
    opacity="0.9",
    width="27.5rem",
    height="27.5rem",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
    //   xmlns:xlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 275 275"
    >
      <defs>
        <filter
          id="Ellipse_290"
          x="0"
          y="0"
          width="275"
          height="275"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Group_6417"
        data-name="Group 6417"
        transform="translate(14.828 11.828)"
      >
        <g
          transform="matrix(1, 0, 0, 1, -14.83, -11.83)"
          filter="url(#Ellipse_290)"
        >
          <circle
            id="Ellipse_290-2"
            data-name="Ellipse 290"
            cx="122.5"
            cy="122.5"
            r="122.5"
            transform="translate(15 12)"
            fill={fill}
            opacity={opacity}
          />
        </g>
      </g>
    </svg>
  );
};

export default BoxShadowIcon;